import { render, staticRenderFns } from "./JobReportsTable.vue?vue&type=template&id=4d78d48e&"
import script from "./JobReportsTable.vue?vue&type=script&lang=js&"
export * from "./JobReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports